import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AdminSalonWaitlistEntry {
  id: string;
  user_id: string;
  event_id: string;
  status: string;
  created_at: string;
  invited_at: string | null;
  profiles: {
    first_name: string | null;
    last_name: string | null;
    email: string | null;
  } | null;
  events: {
    title: string | null;
    start_time: string | null;
    timezone: string | null;
    capacity: number | null;
  } | null;
}

export const useAdminSalonWaitlist = () => {
  return useQuery({
    queryKey: ['admin-salon-waitlist'],
    queryFn: async () => {
      // Get all waitlist entries with joins
      const { data, error } = await supabase
        .from('salon_waitlist')
        .select(`
          id,
          user_id,
          event_id,
          status,
          created_at,
          invited_at,
          requested_at,
          profiles!user_id (
            first_name,
            last_name,
            email
          ),
          events!event_id (
            title,
            start_time,
             timezone,
            capacity
          )
        `)
        .order('created_at', { ascending: false });

      if (error) throw error;

      // Filter for Secret Salon events
      const filteredData = data?.filter((entry) => {
        // Check if event has Secret Salon tag - this will be done via event_tags
        return true; // For now return all, we'll add tag filtering if needed
      });

      return filteredData as AdminSalonWaitlistEntry[];
    },
  });
};
